import React from "react";
import * as Yup from "yup";

import "utils/yup-validation";
import RemoveReferralForm from "./form";

export default ({ orgUnitId, referralId, onSucceed }) => {
  const schema = Yup.object().shape({
    referral: Yup.object().shape({
      removedReason: Yup.string()
        .trim()
        .required("Reason for Removal is required")
        .max(500, "Reason for Removal exceeds maximum length of 500 characters")
        .default(""),
    }),
  });

  const contentProps = {
    title: "Remove Referral",
  };

  return (
    <RemoveReferralForm
      schema={schema}
      orgUnitId={orgUnitId}
      referralId={referralId}
      onSucceed={onSucceed}
      contentProps={contentProps}
    />
  );
};

